import styled from 'styled-components'
import { ParseSurveyResultDataType } from '@app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/container/modules/parseSurveyResultData'
import LabelLayout from '../LevelRatingQuestionLabelLayout.mobile'
import LevelRatingTableMobile from './LevelRatingTable.mobile'
import ResultCard from './ResultCard.mobile'

interface LevelRatingResultBoxMobileProps {
  surveyResultData: ParseSurveyResultDataType
}

const LevelRatingResultBoxMobile = ({
  surveyResultData,
}: LevelRatingResultBoxMobileProps) => {
  const { question1, question2, question3, question5, question6, question4 } =
    surveyResultData

  return (
    <StyledWrapper>
      <LabelLayout label={question1.label}>
        <LevelRatingTableMobile tableDataList={question1.tableDataList} />
      </LabelLayout>
      <LabelLayout label={question2.label}>
        <LevelRatingTableMobile tableDataList={question2.tableDataList} />
      </LabelLayout>
      <LabelLayout label={question3.label}>
        <ResultCard
          mainDataText={question3.mainDataText}
          description={question3.description}
          subText={question3.subText}
        />
      </LabelLayout>
      <LabelLayout label={question4.label}>
        {question4.cardList.map((card, index) => {
          return (
            <ResultCard
              mainDataText={card.mainDataText}
              cardTitle={card.cardTitle}
              description={card.description}
              key={`${card.cardTitle}-${index}`}
            />
          )
        })}
      </LabelLayout>
      <LabelLayout label={question5.label}>
        <ResultCard
          mainDataText={question5.mainDataText}
          description={question5.description}
          subText={question5.subText}
        />
      </LabelLayout>
      <LabelLayout label={question6.label}>
        {question6.cardList.map((card, index) => {
          return (
            <ResultCard
              mainDataText={card.mainDataText}
              cardTitle={card.cardTitle}
              subText={card.subText}
              key={`${card.cardTitle}-${index}`}
            />
          )
        })}
      </LabelLayout>
    </StyledWrapper>
  )
}

export default LevelRatingResultBoxMobile

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  padding: 32px 24px;
  width: 100%;
  min-height: 300px;
  border-radius: 20px;
  border: solid 1px #e8e8e8e8;
  background-color: #fff;
`
